import React from 'react';
import { ModernHeader } from '../components/ModernHeader';
import { Footer } from '../components/Footer';
import { Truck, RotateCcw, Clock, FileText, AlertTriangle } from 'lucide-react';
export function ShippingPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-801">
      <ModernHeader data-id="element-802" />

      {/* Page Header Banner */}
      <section className="bg-gray-800 py-12" data-id="element-803">
        <div className="max-w-7xl mx-auto px-4" data-id="element-804">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-805">
            Shipping & Returns
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <main className="py-12 md:py-16" data-id="element-806">
        <div className="max-w-4xl mx-auto px-4 space-y-8" data-id="element-807">
          {/* Return Policy Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-808">
            <div className="flex items-center gap-3 mb-6" data-id="element-809">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center" data-id="element-810">
                <RotateCcw className="w-5 h-5 text-red-700" data-id="element-811" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-812">
                Return Policy
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-813">
              <p data-id="element-814">
                You may return product within <strong data-id="element-815">15 days</strong> of
                placing your order. Product must be in its original
                condition/packaging (unopened sealed packages and clean).
                Returned item can't be disassembled or damaged by assembly or
                neglect. Any errors must be reported within{' '}
                <strong data-id="element-816">10 days</strong> of the delivery of your product.
              </p>

              <p data-id="element-817">
                Product returns that are returned for credit will be subject to{' '}
                <strong data-id="element-818">twenty-five percent (25%) restocking fee</strong>.
              </p>

              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-4" data-id="element-819">
                <div className="flex items-start gap-3" data-id="element-820">
                  <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-821" />
                  <div className="text-sm text-amber-800" data-id="element-822">
                    <p className="font-semibold mb-1" data-id="element-823">Important Notes:</p>
                    <ul className="list-disc list-inside space-y-1" data-id="element-824">
                      <li data-id="element-825">
                        Special-ordered products are NOT returnable for any
                        reason
                      </li>
                      <li data-id="element-826">
                        Returned goods without authorization number (RGA#) will
                        be rejected
                      </li>
                      <li data-id="element-827">
                        Please send request for RGA# via email or fax only
                      </li>
                      <li data-id="element-828">Shipping Fees & Taxes are not refundable</li>
                      <li data-id="element-829">
                        Free shipping items will be refunded less shipping fees
                        we paid to ship the product to you
                      </li>
                      <li data-id="element-830">AMEX is no longer accepted</li>
                    </ul>
                  </div>
                </div>
              </div>

              <p className="text-sm text-gray-600 italic" data-id="element-831">
                If a wrongful chargeback is filed, cases will be filed in court
                in Pinellas County FL. All court fees and expenses will be
                included in the case.
              </p>
            </div>
          </div>

          {/* Shipping & Handling Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-832">
            <div className="flex items-center gap-3 mb-6" data-id="element-833">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-834">
                <Truck className="w-5 h-5 text-blue-700" data-id="element-835" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-836">
                Shipping & Handling
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-837">
              <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-838">
                <p className="font-semibold text-green-800 mb-2" data-id="element-839">
                  FREE SHIPPING - USA ONLY
                </p>
                <p className="text-sm text-green-700" data-id="element-840">
                  If the item states FREE SHIPPING, this applies to USA orders
                  only. Purchases from outside the USA will be cancelled and
                  refunded less a processing fee.
                </p>
              </div>

              <p data-id="element-841">
                Once an order has been paid we generally cannot cancel the
                order. If we are able to stop the order, the refund is subject
                to a <strong data-id="element-842">$5.00 fee or 20% of the sale</strong>. You will
                need to request an RGA and return the product to us. If an order
                is refused, additional handling and shipping fees will be
                assessed to the refund.
              </p>

              <p data-id="element-843">
                All orders are processed daily and shipped out based on stock
                availability. We ship via{' '}
                <strong data-id="element-844">UPS, USPS and Truck Service</strong>.
              </p>
            </div>
          </div>

          {/* Shipping Fees Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-845">
            <div className="flex items-center gap-3 mb-6" data-id="element-846">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-847">
                <FileText className="w-5 h-5 text-purple-700" data-id="element-848" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-849">
                Shipping Fees
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-850">
              <p data-id="element-851">
                We provide selections of shipping methods & virtual cost options
                from UPS and USPS live shipping processor.
              </p>

              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-852">
                <li data-id="element-853">
                  Due to UPS Services & Policies, delivery to P.O. Box addresses
                  is not available
                </li>
                <li data-id="element-854">
                  New shipping option: <strong data-id="element-855">Flat Rate Priority USPS</strong>{' '}
                  - Contact us for availability and rates
                </li>
                <li data-id="element-856">
                  If your address is residential, you must select the applicable
                  service
                </li>
                <li data-id="element-857">
                  If a commercial service is chosen for a residential address,
                  an appropriate alternate service may be selected at our
                  discretion
                </li>
                <li data-id="element-858">
                  We reserve the right to change the shipping mode of a shipment
                  if necessary
                </li>
              </ul>
            </div>
          </div>

          {/* Shipping Status Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-859">
            <div className="flex items-center gap-3 mb-6" data-id="element-860">
              <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center" data-id="element-861">
                <Clock className="w-5 h-5 text-teal-700" data-id="element-862" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-863">
                Shipping Status & Tracking
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-864">
              <p data-id="element-865">
                All in stock orders are shipped within{' '}
                <strong data-id="element-866">1-2 business days</strong>. Orders with rush delivery
                such as Overnight, 2nd Day, and 3 Days usually ship out same day
                based on stock availability, otherwise you will be notified.
              </p>

              <p data-id="element-867">
                <strong data-id="element-868">Our shipping deadline is 3:00 PM ET.</strong>
              </p>

              <p data-id="element-869">
                You will be notified by email or you may login to your account
                and check your order under "View Order History" regarding the
                status.
              </p>

              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mt-4" data-id="element-870">
                <p className="text-sm text-gray-600" data-id="element-871">
                  <strong data-id="element-872">Please note:</strong> UPS overnight and 2nd Day
                  shipping does not include the weekend on their delivery times.
                  All delivery times are estimates and not guaranteed. Estimated
                  delivery times include seller's handling time (business days
                  and time), and will depend on shipping service selected and
                  receipt of cleared payment. Delivery times may vary,
                  especially during peak periods and can be impacted by weather.
                  We reserve the right to cancel any order prior to shipping
                  product.
                </p>
              </div>

              <div className="bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-873">
                <p className="font-semibold text-red-800" data-id="element-874">
                  Shipping Dept is Closed on Saturdays, Sundays and All National
                  Holidays.
                </p>
              </div>
            </div>
          </div>

          {/* Specifications & Information Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-875">
            <div className="flex items-center gap-3 mb-6" data-id="element-876">
              <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-877">
                <FileText className="w-5 h-5 text-gray-700" data-id="element-878" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-879">
                Specifications & Information
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed text-sm" data-id="element-880">
              <p data-id="element-881">
                All specifications and/or information related to each or any
                item listed on this web site has been gathered from various
                manufacturers or factories. Specifications are based on basic
                and international industrial standards and any published
                catalogs or specifications are prepared and produced by original
                manufacturer.
              </p>

              <p data-id="element-882">
                We do not publish or produce any product(s) specification and/or
                information related to products or goods listed in this "USA
                Bearings & Belts" web site. USA Bearings & Belts is not
                responsible for any mistake or miscalculation within the
                Catalogs.
              </p>

              <p data-id="element-883">
                Provided Catalogs on the USA Bearings & Belts web site are
                determined to serve the consumers with basic information as a
                guide. This web site "USA Bearings & Belts" has gathered product
                and information made by different manufacturing and/or
                factories, to supply and serve our customers with cost effective
                bearings and related products for the purchase at their
                convenience.
              </p>

              <p className="text-xs text-gray-500 italic border-t border-gray-200 pt-4 mt-4" data-id="element-884">
                Any copies made from our site Trademarks USA Bearings & Belts
                and USBB Brands remain our property and copies will be charged
                and prosecuted in Pinellas County Florida.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-885" />
    </div>;
}